import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";

import { BaseMatDialogContainer } from "./base-mat-dialog.container";

@Component({
	templateUrl: "./base-mat-dialog.container.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.Default,
})
export class NativeMatDialogContainer extends BaseMatDialogContainer {
	@HostBinding("@.disabled") animation = true;
}
